export const validState = (isEmptyState: Boolean) => {
  if (isEmptyState) {
    return {
      isEmptyState: false,
    };
  }

  return {};
};
